import {
  Component,
  Host,
  h,
  Element,
} from "@stencil/core";

import { setPropsIfNull } from "../../../utils/utils";

/**
 * @slot - Slot for label
 */
@Component({
  tag: "stzh-print",
  styleUrl: "stzh-print.scss",
  shadow: true
})
export class StzhPrint {
  @Element() element: HTMLStzhPrintElement;

  private observer: MutationObserver;

  private handleLinkClick = () => {
    window.print();
  }

  private init = () => {
    const links = this.element.querySelectorAll("stzh-link, stzh-button");

    links.forEach((link) => {
      link.addEventListener('click', this.handleLinkClick);

      setPropsIfNull(link, {
        icon: "print"
      } as HTMLStzhLinkElement | HTMLStzhButtonElement)
    });
  }

  connectedCallback() {
    this.init();

    this.observer = new MutationObserver(this.init);
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    const classes = {
      "stzh-print": true
    };

    return (
      <Host>
        <div class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
